import { styled } from '@mui/material/styles'

export const StyledHeaderPlanning = styled('div')({
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    height: '10px', // hauteur de la scrollbar horizontale
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'blue',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
})
export const StyledDivSwitch = styled('div')({
  paddingLeft: '0px',
  paddingRight: '0px',
  display: 'flex',
  alignItems: 'center',
})
